var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ViewIdentity',{attrs:{"name":"Booked Orders"}}),_c('div',{staticClass:"container-fluid"},[_c('div',[_c('OrderTable')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }